// // import React, { useState } from "react";
// // import DatePicker from "react-datepicker";
// // import "react-datepicker/dist/react-datepicker.css";
// // import moment from "moment";
// // import Calendar from "react-calendar";

// // import "react-calendar/dist/Calendar.css";

// // const BookingComponent = () => {
// //   // let host = "https://api.vmrdarental.com";
// //   let host = "https://api.vmrdarental.com";
// //   const [selectedVenue, setSelectedVenue] = useState("MGM Lawn");
// //   const [selectedRoomType, setSelectedRoomType] = useState("MGM1");
// //   const [calendarDates, setCalendarDates] = useState([new Date(), new Date()]);
// //   const [selectedLocation, serSelectedLocation] = useState();
// //   const [concessionType, setConcessionType] = useState("");
// //   const [price, setPrice] = useState("");
// //   const [startDate, setStartDate] = useState(new Date());
// //   const [endDate, setEndDate] = useState(new Date());

// //   const handleBook = () => {
// //     alert(`Booking Details:
// //     Venue: ${selectedVenue}
// //     Room Type: ${selectedRoomType}
// //     Concession Type: ${concessionType}
// //     Price: ${price}
// //     Start Date: ${startDate.toDateString()}
// //     End Date: ${endDate.toDateString()}
// //     `);
// //   };

// //   const handleCalendarChange = async (dates) => {
// //     setCalendarDates(dates);
// //     if (selectedLocation) {
// //       const formattedDates = dates.map((date) =>
// //         moment(date).format("YYYY-MM-DD")
// //       );
// //       try {
// //         const response = await fetch(
// //           `${host}/get-calendar-rooms?location=${selectedLocation}&date=${formattedDates.join(
// //             ","
// //           )}`
// //         );
// //         const data = await response.json();
// //         console.log("Room availability:", data);
// //       } catch (error) {
// //         console.error("Error fetching calendar room data:", error);
// //       }
// //     }
// //   };

// //   return (
// //     <div style={{ textAlign: "center", padding: "20px" }}>
// //       <div
// //         style={{
// //           display: "flex",
// //           justifyContent: "center",
// //           gap: "10px",
// //           marginBottom: "20px",
// //         }}
// //       >
// //         {/* Venue Dropdown */}
// //         <div>
// //           <label>Venue: </label>
// //           <select
// //             value={selectedVenue}
// //             onChange={(e) => setSelectedVenue(e.target.value)}
// //           >
// //             <option value="MGM Lawn">MGM Lawn</option>
// //             <option value="Hall 1">Hall 1</option>
// //             <option value="Hall 2">Hall 2</option>
// //           </select>
// //         </div>

// //         {/* Room Type Dropdown */}
// //         <div>
// //           <label>Room Type: </label>
// //           <select
// //             value={selectedRoomType}
// //             onChange={(e) => setSelectedRoomType(e.target.value)}
// //           >
// //             <option value="MGM1">MGM1</option>
// //             <option value="MGM2">MGM2</option>
// //           </select>
// //         </div>
// //       </div>

// //       {/* Calendars */}
// //       <div
// //         style={{
// //           display: "flex",
// //           justifyContent: "center",
// //           gap: "20px",
// //           marginBottom: "20px",
// //         }}
// //       >
// //         <Calendar
// //           selectRange
// //           value={calendarDates}
// //           onChange={handleCalendarChange}
// //           minDate={new Date()}
// //           showDoubleView={true}
// //         />
// //       </div>

// //       {/* Concession Type and Price */}
// //       <div style={{ marginBottom: "20px" }}>
// //         <label>Concession Type: </label>
// //         <select
// //           value={concessionType}
// //           onChange={(e) => setConcessionType(e.target.value)}
// //         >
// //           <option value="">Select</option>
// //           <option value="Corporate">Corporate</option>
// //           <option value="Wedding">Wedding</option>
// //           <option value="Personal">Personal</option>
// //         </select>
// //       </div>
// //       <div style={{ marginBottom: "20px" }}>
// //         <label>Price: </label>
// //         <input
// //           type="text"
// //           value={price}
// //           onChange={(e) => setPrice(e.target.value)}
// //           placeholder="Enter price"
// //         />
// //       </div>

// //       {/* Book Button */}
// //       <button
// //         onClick={handleBook}
// //         style={{ padding: "10px 20px", fontSize: "16px", cursor: "pointer" }}
// //       >
// //         Book
// //       </button>
// //     </div>
// //   );
// // };

// // export default BookingComponent;

// import React, { useState, useEffect, useRef } from "react";
// import Calendar from "react-calendar";
// // import "react-calendar/dist/Calendar.css";
// import "./Booking.css";
// import { useNavigate } from "react-router-dom";
// import Header from "./Header";
// import DatePicker from "react-multi-date-picker";
// import "react-datepicker/dist/react-datepicker.css";
// // import "react-multi-date-picker/styles/colors/teal.css";
// import AccomodationImages from "./AccomodationImages";
// import PreviewPage from "./PreviewPage";
// const BookingComponent = () => {
//   const navigate = useNavigate();
//   const [locations, setLocations] = useState([]);
//   const [roomTypes, setRoomTypes] = useState([]);

//   const [selectedVenue, setSelectedVenue] = useState(
//     localStorage.getItem("selectedVenue") || ""
//   ); // Retrieve from localStorage
//   const [selectedRoomType, setSelectedRoomType] = useState(
//     localStorage.getItem("selectedRoomType") || ""
//   ); // Retrieve from localStorage
//   const [calendarDates, setCalendarDates] = useState([new Date(), new Date()]);
//   const [availableDates, setAvailableDates] = useState([]);
//   const [bookedDates, setBookedDates] = useState([]);
//   const [concessionType, setConcessionType] = useState("");
//   const [amount, setAmount] = useState(0);
//   const [price, setPrice] = useState("");
//   const [roomDetails, setRoomDetails] = useState(null);
//   // const [selectedLocationName, setSelectedLocationName] = useState("");
//   const [selectedLocationName, setSelectedLocationName] = useState(
//     localStorage.getItem("selectedVenueName") || ""
//   );

//   const [isDateRangeValid, setIsDateRangeValid] = useState(false);

//   const [isDoubleView, setIsDoubleView] = useState(window.innerWidth > 768);
//   // const [selectedDate, setSelectedDate] = useState(null);
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [values, setValues] = useState([
//     new Date(new Date().setMonth(new Date().getMonth() - 1)), // subtract 1 month
//     new Date(new Date().setMonth(new Date().getMonth() + 1)), // add 1 month
//   ]);
//   const [selectedLocation, setSelectedLocation] = useState();
//   const [selectedRoom, setSelectedRoom] = useState();
//   const datePickerRef = useRef(null);
//   const [showPreview, setShowPreview] = useState(false);
//   const [bookingDetails, setBookingDetails] = useState(null);
//   const previewSectionRef = useRef(null);
//   const userRole = localStorage.getItem("userRole");
//   useEffect(() => {
//     // Keep the calendar open on initial load
//     if (datePickerRef.current) {
//       datePickerRef.current.openCalendar();
//     }
//   }, []);

//   const handleCalendarChange = (selectedRange) => {
//     if (!selectedRange || selectedRange.length !== 2) {
//       setIsDateRangeValid(false);
//       return;
//     }

//     const [start, end] = selectedRange.map((date) => formatDateToLocal(date));
//     if (!start || !end) {
//       setIsDateRangeValid(false);
//       return;
//     }

//     if (new Date(start) > new Date(end)) {
//       alert("Invalid date range! 'From' date cannot be after 'To' date.");
//       setIsDateRangeValid(false);
//       return;
//     }

//     const selectedDates = generateDateRange(start, end);
//     const bookedDates = availableDates
//       .filter((d) => d.status === "booked")
//       .map((d) => d.date);

//     const isConflict = selectedDates.some((date) => bookedDates.includes(date));

//     if (isConflict) {
//       alert(
//         "One or more selected dates are already booked. Please select a different range."
//       );
//       setIsDateRangeValid(false);
//       return;
//     }

//     // Store valid selection
//     setCalendarDates(selectedRange);
//     localStorage.setItem("selectedDateRange", JSON.stringify(selectedRange));

//     // Enable proceed button
//     setIsDateRangeValid(true);
//   };

//   const generateDateRange = (startDate, endDate) => {
//     const dates = [];
//     let currentDate = new Date(startDate);

//     while (currentDate <= new Date(endDate)) {
//       dates.push(formatDateToLocal(currentDate));
//       currentDate.setDate(currentDate.getDate() + 1);
//     }

//     return dates;
//   };

//   // Prevent the calendar from closing when clicking outside
//   const handleClick = (event) => {
//     if (
//       datePickerRef.current &&
//       !datePickerRef.current.contains(event.target)
//     ) {
//       event.stopPropagation(); // Prevent the event from closing the picker
//       datePickerRef.current.openCalendar(); // Reopen the calendar if closed
//     }
//   };

//   useEffect(() => {
//     // Add event listener for clicks outside to prevent closing
//     document.addEventListener("click", handleClick);

//     // Cleanup the event listener on unmount
//     return () => {
//       document.removeEventListener("click", handleClick);
//     };
//   }, []);

//   // Fetch static locations
//   useEffect(() => {
//     const locationsData = [
//       { id: 1, name: "Gurajada Kalakshetram" },
//       { id: 2, name: "MGM LAwN" },
//       { id: 3, name: "Chinnamusidivada" },
//       { id: 4, name: "Children's Arena" },
//     ];
//     setLocations(locationsData);
//   }, []);

//   // Fetch room types whenever the selected venue changes
//   useEffect(() => {
//     if (selectedVenue) fetchRooms(selectedVenue);
//   }, [selectedVenue]);

//   useEffect(() => {
//     if (Array.isArray(calendarDates) && calendarDates.length === 2) {
//       fetchAvailableRooms(calendarDates);
//       fetchBookedRooms(calendarDates);
//     }
//   }, [calendarDates, selectedVenue]);

//   useEffect(() => {
//     if (selectedRoomType && selectedVenue && calendarDates.length === 2) {
//       fetchAvailableRoomsByRoom(calendarDates, selectedVenue, selectedRoomType);
//       fetchBookedRooms(calendarDates); // Ensure booked rooms are fetched again
//     }
//   }, [selectedRoomType, selectedVenue, calendarDates]);

//   // Fetch rooms
//   const fetchRooms = async (locationId) => {
//     try {
//       const response = await fetch(
//         `https://api.vmrdarental.com/get-rooms?location=${locationId}`
//       );
//       const data = await response.json();

//       const roomOptions = data.map((room) => ({
//         id: room.room_id,
//         name: room.room_name,
//         purposes: room.purposes || [],
//         amounts: room.amounts || {},
//       }));
//       setRoomTypes(roomOptions);
//       setSelectedRoomType(roomOptions[0]?.id || "");
//       setRoomDetails(roomOptions[0] || null);
//     } catch (err) {
//       console.error("Error fetching rooms:", err);
//     }
//   };

//   const fetchBookedRooms = async (dates) => {
//     if (!Array.isArray(dates) || dates.length !== 2) {
//       console.error("Invalid dates passed to fetchBookedRooms:", dates);
//       return;
//     }

//     const [startDate, endDate] = dates;

//     // Format dates correctly
//     const formattedStartDate = formatDateToLocal(startDate);
//     const formattedEndDate = formatDateToLocal(endDate);

//     console.log("Selected Dates:", formattedStartDate, formattedEndDate); // Debugging

//     try {
//       const response = await fetch(
//         `https://api.vmrdarental.com/get-booked-rooms?location=${selectedVenue}&start_date=${formattedStartDate}&end_date=${formattedEndDate}`
//       );

//       const { data } = await response.json();

//       console.log("API Response:", data);

//       // Assuming API response contains booked rooms
//       const bookedRooms = data.map((item) => item.room_id);
//       setBookedDates(bookedRooms);
//     } catch (error) {
//       console.error("Error fetching booked rooms:", error);
//     }
//   };

//   const fetchAvailableRooms = async (dates) => {
//     const [startDate, endDate] = dates;
//     const formattedStartDate = formatDateToLocal(startDate);
//     const formattedEndDate = formatDateToLocal(endDate);

//     try {
//       const response = await fetch(
//         `https://api.vmrdarental.com/get-calendar-rooms?location=${selectedVenue}&date=${formattedStartDate},${formattedEndDate}`
//       );
//       const { availability } = await response.json();

//       const parsedAvailability = Object.entries(availability).map(
//         ([date, info]) => ({
//           date,
//           status: info.status,
//           count: info.count,
//         })
//       );

//       setAvailableDates(parsedAvailability); // Update state
//     } catch (error) {
//       console.error("Error fetching available rooms:", error);
//     }
//   };

//   const formatDateToLocal = (date) => {
//     if (!(date instanceof Date)) {
//       date = new Date(date); // Convert to Date object if it's not already
//     }

//     if (isNaN(date.getTime())) {
//       console.error("Invalid date provided:", date);
//       return null; // Return null for invalid dates
//     }

//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
//     const day = String(date.getDate()).padStart(2, "0");

//     return `${year}-${month}-${day}`;
//   };

//   const handleVenueChange = (e) => {
//     const venueId = e.target.value;
//     setSelectedVenue(venueId);

//     // Store the selected venue in localStorage
//     localStorage.setItem("selectedVenue", venueId);
//     const venueName =
//       locations.find((location) => location.id === parseInt(venueId))?.name ||
//       "";
//     setSelectedLocationName(venueName);
//     localStorage.setItem("selectedVenueName", venueName);
//   };

//   const handleDateSelection = (selectedRange) => {
//     const [startDate, endDate] = selectedRange;

//     if (!endDate) {
//       // If only one date is selected, treat it as both start and end date
//       fetchAvailableRooms([startDate, startDate]);
//     } else {
//       fetchAvailableRooms([startDate, endDate]);
//     }
//   };

//   // Handle concession type selection change
//   const handlePurposeChange = (purposeName) => {
//     setConcessionType(purposeName);
//     const selectedAmount = roomDetails?.amounts[purposeName];
//     if (selectedAmount) {
//       setAmount(selectedAmount.price);
//       setPrice(selectedAmount.rent);
//     }
//   };

//   const handleBook = (selectedRoomId) => {
//     if (bookedDates.includes(selectedRoomId)) {
//       alert("This room is already booked. Please select a different room.");
//       return;
//     }
//     if (!concessionType) {
//       alert("Please select a concession type.");
//       return;
//     }

//     const [startDate, endDate] = calendarDates;
//     const start = new Date(startDate);
//     const end = new Date(endDate);
//     start.setHours(0, 0, 0, 0);
//     end.setHours(0, 0, 0, 0);

//     const selectedDaysCount =
//       Math.round((end - start) / (1000 * 60 * 60 * 24)) + 1;
//     const localDate = new Date(
//       start.getTime() - start.getTimezoneOffset() * 60000
//     )
//       .toISOString()
//       .split("T")[0];
//     const bookingDetailsData = {
//       locationId: selectedVenue,
//       locationName: selectedLocationName,
//       roomName: roomDetails?.name || "",
//       roomId: selectedRoomType,
//       // date: start.toISOString().split("T")[0],
//       date: localDate,
//       fromDate: start.toDateString(),
//       toDate: end.toDateString(),
//       dateRange: calendarDates,
//       daysStay: selectedDaysCount.toString(),
//       selectedDateRange: [start.getTime(), end.getTime()],
//       selectedRooms: [
//         {
//           room_id: selectedRoomType,
//           room_name: roomDetails?.name || "",
//           location_id: selectedVenue,
//           accommodation_type: roomDetails?.accommodationType || "Unknown",
//           amount: amount,
//           price: price,
//           purpose: concessionType,
//         },
//       ],
//     };

//     localStorage.setItem(
//       "selectedRoomData",
//       JSON.stringify(bookingDetailsData)
//     );

//     const accessToken = localStorage.getItem("access_token"); // Corrected key name
//     setBookingDetails(bookingDetailsData);
//     setShowPreview(true);
//     if (accessToken && accessToken.trim() !== "") {
//       // Navigate to preview page if token is valid
//       navigate("/", {
//         state: {
//           ...bookingDetailsData,
//         },
//       });
//     } else {
//       // Redirect to login if no token
//       alert("Please login to proceed.");
//       navigate("/login", {
//         state: {
//           from: "/",
//         },
//       });
//     }
//   };

//   const handleBlock = (selectedRoomId) => {
//     // Check if the room is already booked
//     if (bookedDates.includes(selectedRoomId)) {
//       alert("This room is already booked. Please select a different room.");
//       return;
//     }

//     // Check if the concession type is selected
//     if (!concessionType) {
//       alert("Please select a concession type.");
//       return;
//     }

//     // Get the selected date range and calculate the days stay
//     const [startDate, endDate] = calendarDates;
//     const start = new Date(startDate);
//     const end = new Date(endDate);
//     start.setHours(0, 0, 0, 0);
//     end.setHours(0, 0, 0, 0);

//     const selectedDaysCount =
//       Math.round((end - start) / (1000 * 60 * 60 * 24)) + 1;

//     // Prepare the booking details
//     const bookingDetailsData = {
//       locationId: selectedVenue,
//       locationName: selectedLocationName,
//       roomName: roomDetails?.name || "",
//       roomId: selectedRoomType,
//       date: start.toISOString().split("T")[0],
//       fromDate: start.toDateString(),
//       toDate: end.toDateString(),
//       dateRange: calendarDates,
//       daysStay: selectedDaysCount.toString(),
//       selectedDateRange: [start.getTime(), end.getTime()],
//       selectedRooms: [
//         {
//           room_id: selectedRoomType,
//           room_name: roomDetails?.name || "",
//           location_id: selectedVenue,
//           accommodation_type: roomDetails?.accommodationType || "Unknown",
//           amount: amount,
//           price: price,
//           purpose: concessionType,
//         },
//       ],
//     };

//     // Store the booking details in localStorage
//     localStorage.setItem(
//       "selectedRoomData",
//       JSON.stringify(bookingDetailsData)
//     );

//     // Retrieve access token from localStorage
//     const accessToken = localStorage.getItem("access_token"); // Correct key name

//     // Store booking details in state and show preview modal
//     setBookingDetails(bookingDetailsData);
//     setShowPreview(true);

//     // Redirect based on the availability of access token
//     if (accessToken && accessToken.trim() !== "") {
//       // Navigate to roomBlockingPreview page if the user is logged in
//       navigate("/roomBlockingPreview", {
//         state: {
//           ...bookingDetailsData,
//         },
//       });
//     } else {
//       // Redirect to login page if no access token is found
//       alert("Please login to proceed.");
//       navigate("/login", {
//         state: {
//           from: "/",
//         },
//       });
//     }
//   };

//   const handleBack = () => {
//     // Reset all state and localStorage
//     // setSelectedVenue("");
//     // setSelectedRoomType("");
//     setCalendarDates([new Date(), new Date()]);
//     setConcessionType("");
//     setAmount(0);
//     setPrice("");
//     setShowPreview(false);
//     setBookingDetails(null);
//     setAvailableDates([]);
//     setRoomDetails(null);

//     localStorage.removeItem("selectedVenue");
//     localStorage.removeItem("selectedRoomType");
//     localStorage.removeItem("selectedRoomData");

//     // Navigate back to the home or previous page
//     navigate("/");
//   };
//   // const handleDateClick = (date) => {
//   //   setSelectedDate(date); // Update the selected date
//   // };
//   setTimeout(() => {
//     previewSectionRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, 100); // Delay to ensure the section is visible
//   const handleDateClick = (date) => {
//     const selectedRange = [date, date]; // Treat clicked date as both start and end date
//     setCalendarDates(selectedRange);
//     fetchAvailableRooms(selectedRange);
//   };
//   // Example: Fetching dates from the picker
//   const handleDateChange = ({ startDate, endDate }) => {
//     if (startDate && endDate) {
//       fetchBookedRooms([startDate, endDate]);
//     }
//   };

//   const fetchAvailableRoomsByLocation = async (dates, locationId) => {
//     const [startDate, endDate] = dates;
//     const formattedStartDate = formatDateToLocal(startDate);
//     const formattedEndDate = formatDateToLocal(endDate);

//     try {
//       const response = await fetch(
//         `https://api.vmrdarental.com/get-calendar-rooms?location=${locationId}&date=${formattedStartDate},${formattedEndDate}`
//       );
//       const { availability } = await response.json();

//       const parsedAvailability = Object.entries(availability).map(
//         ([date, info]) => ({
//           date,
//           status: info.status,
//           count: info.count,
//         })
//       );

//       setAvailableDates(parsedAvailability);
//     } catch (error) {
//       console.error("Error fetching available rooms by location:", error);
//     }
//   };
//   const handleRoomChange = (e) => {
//     const roomId = e.target.value;
//     setSelectedRoomType(roomId);

//     // Fetch room-specific availability
//     fetchAvailableRoomsByRoom(calendarDates, selectedVenue, roomId);

//     // Update local room details
//     const room = roomTypes.find((r) => r.id === parseInt(roomId));
//     setRoomDetails(room);
//     setConcessionType("");
//     setAmount(0);
//     setPrice("");

//     // Store the selected room in localStorage
//     localStorage.setItem("selectedRoomType", roomId);
//     localStorage.setItem("selectedRoomName", room?.name || "");
//   };

//   const fetchAvailableRoomsByRoom = async (dates, locationId, roomId) => {
//     const [startDate, endDate] = dates;
//     const formattedStartDate = formatDateToLocal(startDate);
//     const formattedEndDate = formatDateToLocal(endDate);

//     try {
//       const response = await fetch(
//         `https://api.vmrdarental.com/get-calendar-rooms?location=${locationId}&room_id=${roomId}&date=${formattedStartDate},${formattedEndDate}`
//       );

//       const jsonResponse = await response.json();
//       console.log("Available Rooms Response:", jsonResponse); // Debugging

//       const { availability } = jsonResponse;

//       const parsedAvailability = Object.entries(availability).map(
//         ([date, info]) => ({
//           date,
//           status: info.status,
//           count: info.count,
//         })
//       );

//       setAvailableDates(parsedAvailability);
//     } catch (error) {
//       console.error("Error fetching available rooms by room:", error);
//     }
//   };

//   const handleLocationChange = (e) => {
//     const locationId = e.target.value;
//     setSelectedLocation(locationId);

//     // Fetch data for the selected location
//     fetchAvailableRoomsByLocation(calendarDates, locationId);
//   };

//   // return (
//   //   <div>
//   //     <Header />

//   //     <div className="booking-container">
//   //       {/* <AccomodationImages /> */}
//   //       <h2 className="booking-header">Venue Booking</h2>

//   //       {/* Venue and Room Selection */}
//   //       <div className="card">
//   //         <h3 className="section-header">Venue Selection</h3>
//   //         <div className="form-row">
//   //           <div className="form-group">
//   //             <label>Venue</label>
//   //             <select
//   //               value={selectedVenue}
//   //               onChange={handleVenueChange}
//   //               className="styled-select"
//   //               disabled={showPreview}
//   //             >
//   //               <option value="">Select Venue</option>
//   //               {locations.map((location) => (
//   //                 <option key={location.id} value={location.id}>
//   //                   {location.name}
//   //                 </option>
//   //               ))}
//   //             </select>
//   //           </div>

//   //           <div className="form-group col-lg-6">
//   //             <label>Select Venue Type</label>
//   //             <select
//   //               value={selectedRoomType}
//   //               onChange={handleRoomChange}
//   //               className="styled-select"
//   //               disabled={showPreview}
//   //             >
//   //               <option value="">Select Venue Type</option>
//   //               {roomTypes.map((room) => (
//   //                 <option key={room.id} value={room.id}>
//   //                   {room.name}
//   //                 </option>
//   //               ))}
//   //             </select>
//   //           </div>
//   //         </div>
//   //       </div>

//   //       {/* Calendar */}
//   //       <div className="">
//   //         <h3 className="section-header">select From and To date</h3>
//   //         <div className="calendar-section">
//   //           <DatePicker
//   //             ref={datePickerRef}
//   //             value={calendarDates}
//   //             onChange={handleCalendarChange}
//   //             inline
//   //             range
//   //             numberOfMonths={2}
//   //             minDate={new Date()}
//   //             format="DD MMM YYYY"
//   //             mapDays={({ date }) => {
//   //               const formattedDate = formatDateToLocal(date);

//   //               if (!formattedDate) return {};

//   //               const today = new Date();
//   //               today.setHours(0, 0, 0, 0); // Reset to start of the day
//   //               const currentDate = new Date(date);
//   //               currentDate.setHours(0, 0, 0, 0); // Reset to start of the day

//   //               // Style for past dates
//   //               if (currentDate < today) {
//   //                 return {
//   //                   style: { backgroundColor: "#d3d3d3", color: "#a0a0a0" },
//   //                   disabled: true,
//   //                 };
//   //               }

//   //               const dayInfo = availableDates.find(
//   //                 (d) => d.date === formattedDate
//   //               );

//   //               if (dayInfo && dayInfo.status === "booked") {
//   //                 return {
//   //                   style: { backgroundColor: "red", color: "white" },
//   //                   disabled: true,
//   //                 };
//   //               } else if (dayInfo && dayInfo.status === "available") {
//   //                 return {
//   //                   style: { backgroundColor: "green", color: "white" },
//   //                 };
//   //               }

//   //               return {}; // Default styling
//   //             }}
//   //           />
//   //         </div>
//   //       </div>

//   //       {/* Concession Section */}
//   //       <div className="row" style={{ marginTop: "42%" }}>
//   //         <div className="card col-lg-6">
//   //           <h3>Concession Type</h3>
//   //           <select
//   //             value={concessionType}
//   //             onChange={(e) => handlePurposeChange(e.target.value)}
//   //             className="styled-select"
//   //             disabled={showPreview}
//   //           >
//   //             <option value="">Select Purpose</option>
//   //             {roomDetails?.purposes?.map((purpose, index) => (
//   //               <option key={index} value={purpose}>
//   //                 {purpose}
//   //               </option>
//   //             ))}
//   //           </select>
//   //         </div>
//   //         {concessionType && roomDetails?.amounts && (
//   //           <div className="card col-lg-6">
//   //             <h3>Amount:</h3>
//   //             <input
//   //               type="text"
//   //               value={`₹${amount}`} // Show the calculated amount based on the selected concession type
//   //               readOnly
//   //               className="styled-select"
//   //               disabled={showPreview}
//   //             />
//   //           </div>
//   //         )}
//   //         {concessionType && roomDetails?.prices && (
//   //           <div className="card col-lg-6">
//   //             <h3>Price:</h3>
//   //             <input
//   //               type="text"
//   //               value={`₹${price}`} // Show the price after selecting the concession type
//   //               readOnly
//   //               className="styled-select"
//   //               disabled={showPreview}
//   //             />
//   //           </div>
//   //         )}{" "}
//   //         {concessionType && (
//   //           <p
//   //             style={{
//   //               marginTop: "10px",
//   //               color: "red",
//   //               fontSize: "18px",
//   //               fontStyle: "italic",
//   //             }}
//   //           >
//   //             Note: Please select the correct proof. If the concession Type and
//   //             proof selection is wrong, the booking may be canceled at any time.
//   //           </p>
//   //         )}
//   //       </div>

//   //       {/* Confirm Booking */}

//   //       <div className="button-section">
//   //         {/* <button
//   //           className="book-button"
//   //           onClick={handleBook}
//   //           disabled={showPreview}
//   //         >
//   //           proceed
//   //         </button>
//   //         <button className="block-button">
//   //           (userRole===1)?
//   //         </button> */}
//   //         <div>
//   //           {userRole === "1" ? (
//   //             <>
//   //               <button
//   //                 className="book-button"
//   //                 onClick={handleBook}
//   //                 disabled={showPreview}
//   //               >
//   //                 Proceed
//   //               </button>
//   //               <button
//   //                 className="book-button"
//   //                 style={{ marginLeft: "10px" }}
//   //                 onClick={handleBlock}
//   //               >
//   //                 Block Venue
//   //               </button>
//   //             </>
//   //           ) : (
//   //             <button
//   //               className="book-button"
//   //               onClick={handleBook}
//   //               disabled={showPreview || !isDateRangeValid}
//   //               style={{ opacity: showPreview || !isDateRangeValid ? 0.5 : 1 }}
//   //             >
//   //               Proceed
//   //             </button>
//   //           )}
//   //         </div>

//   //         {showPreview && bookingDetails && (
//   //           <div className="preview-section" ref={previewSectionRef}>
//   //             <PreviewPage bookingDetails={bookingDetails} />
//   //             <button
//   //               className="back_button"
//   //               style={{ display: "block" }}
//   //               onClick={handleBack}
//   //             >
//   //               Reset
//   //             </button>
//   //           </div>
//   //         )}
//   //       </div>
//   //     </div>
//   //   </div>
//   // );

//   return (
//     <div>
//       <Header />

//       <div className="booking-container">
//         <h2 className="booking-header">Search for Venue Booking</h2>

//         <div className="search-card">
//           {/* Venue Location (From) */}
//           <div className="form-group">
//             <label>From</label>
//             <select
//               value={selectedVenue}
//               onChange={handleVenueChange}
//               className="styled-select"
//               disabled={showPreview}
//             >
//               <option value="">Select Venue Location</option>
//               {locations.map((location) => (
//                 <option key={location.id} value={location.id}>
//                   {location.name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Venue Type (To) */}
//           <div className="form-group">
//             <label>To</label>
//             <select
//               value={selectedRoomType}
//               onChange={handleRoomChange}
//               className="styled-select"
//               disabled={showPreview}
//             >
//               <option value="">Select Venue Type</option>
//               {roomTypes.map((room) => (
//                 <option key={room.id} value={room.id}>
//                   {room.name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Date Selection */}
//           <div className="form-group">
//             <label>Depart On</label>
//             <DatePicker
//               // ref={datePickerRef}
//               value={calendarDates}
//               onChange={handleCalendarChange}
//               // inline
//               range
//               numberOfMonths={2}
//               minDate={new Date()}
//               format="DD MMM YYYY"
//               mapDays={({ date }) => {
//                 const formattedDate = formatDateToLocal(date);

//                 if (!formattedDate) return {};

//                 const today = new Date();
//                 today.setHours(0, 0, 0, 0);
//                 const currentDate = new Date(date);
//                 currentDate.setHours(0, 0, 0, 0);

//                 if (currentDate < today) {
//                   return {
//                     style: { backgroundColor: "#d3d3d3", color: "#a0a0a0" },
//                     disabled: true,
//                   };
//                 }

//                 const dayInfo = availableDates.find(
//                   (d) => d.date === formattedDate
//                 );

//                 if (dayInfo?.status === "booked") {
//                   return {
//                     style: { backgroundColor: "red", color: "white" },
//                     disabled: true,
//                   };
//                 } else if (dayInfo?.status === "available") {
//                   return {
//                     style: { backgroundColor: "green", color: "white" },
//                   };
//                 }

//                 return {};
//               }}
//             />
//           </div>

//           {/* Check Availability Button */}
//           {/* <button className="check-availability-button" onClick={handleBook}>
//             Check Availability
//           </button> */}
//         </div>

//         <div className="row">
//           <div className="card col-lg-6">
//             <h3>Concession Type</h3>
//             <select
//               value={concessionType}
//               onChange={(e) => handlePurposeChange(e.target.value)}
//               className="styled-select"
//               disabled={showPreview}
//             >
//               <option value="">Select Purpose</option>
//               {roomDetails?.purposes?.map((purpose, index) => (
//                 <option key={index} value={purpose}>
//                   {purpose}
//                 </option>
//               ))}
//             </select>
//           </div>
//           {concessionType && roomDetails?.amounts && (
//             <div className="card col-lg-6">
//               <h3>Amount:</h3>
//               <input
//                 type="text"
//                 value={`₹${amount}`} // Show the calculated amount based on the selected concession type
//                 readOnly
//                 className="styled-select"
//                 disabled={showPreview}
//               />
//             </div>
//           )}
//           {concessionType && roomDetails?.prices && (
//             <div className="card col-lg-6">
//               <h3>Price:</h3>
//               <input
//                 type="text"
//                 value={`₹${price}`} // Show the price after selecting the concession type
//                 readOnly
//                 className="styled-select"
//                 disabled={showPreview}
//               />
//             </div>
//           )}{" "}
//           {concessionType && (
//             <p
//               style={{
//                 marginTop: "10px",
//                 color: "red",
//                 fontSize: "18px",
//                 fontStyle: "italic",
//               }}
//             >
//               Note: Please select the correct proof. If the concession Type and
//               proof selection is wrong, the booking may be canceled at any time.
//             </p>
//           )}
//         </div>

//         {/* Confirm Booking */}

//         <div className="button-section">
//           {/* <button
//             className="book-button"
//             onClick={handleBook}
//             disabled={showPreview}
//           >
//             proceed
//           </button>
//           <button className="block-button">
//             (userRole===1)?
//           </button> */}
//           <div>
//             {userRole === "1" ? (
//               <>
//                 <button
//                   className="book-button"
//                   onClick={handleBook}
//                   disabled={showPreview}
//                 >
//                   Proceed
//                 </button>
//                 <button
//                   className="book-button"
//                   style={{ marginLeft: "10px" }}
//                   onClick={handleBlock}
//                 >
//                   Block Venue
//                 </button>
//               </>
//             ) : (
//               <button
//                 className="book-button"
//                 onClick={handleBook}
//                 disabled={showPreview || !isDateRangeValid}
//                 style={{ opacity: showPreview || !isDateRangeValid ? 0.5 : 1 }}
//               >
//                 Proceed
//               </button>
//             )}
//           </div>

//           {showPreview && bookingDetails && (
//             <div className="preview-section" ref={previewSectionRef}>
//               <PreviewPage bookingDetails={bookingDetails} />
//               <button
//                 className="back_button"
//                 style={{ display: "block" }}
//                 onClick={handleBack}
//               >
//                 Reset
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BookingComponent;

import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Nav.css";
import Header from "./Header";

const BookingPage = () => {
  const [selectedVenue, setSelectedVenue] = useState("");
  const [selectedRoomType, setSelectedRoomType] = useState("");
  const [date, setDate] = useState("");

  const locations = [
    { id: 1, name: "Hyderabad" },
    { id: 2, name: "Vijayawada" },
  ];

  const roomTypes = [
    { id: 1, name: "Conference Hall" },
    { id: 2, name: "Banquet Hall" },
  ];

  const handleVenueChange = (e) => setSelectedVenue(e.target.value);
  const handleRoomChange = (e) => setSelectedRoomType(e.target.value);
  const handleDateChange = (e) => setDate(e.target.value);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <div>
      <Header />

      <div className="container">
        {/* Left Side: Search Section */}
        <div className="search-section">
          <h2>Search for Venue Booking</h2>

          <div className="form-group">
            <label>From</label>
            <select value={selectedVenue} onChange={handleVenueChange}>
              <option value="">Select Venue Location</option>
              {locations.map((location) => (
                <option key={location.id} value={location.id}>
                  {location.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>To</label>
            <select value={selectedRoomType} onChange={handleRoomChange}>
              <option value="">Select Venue Type</option>
              {roomTypes.map((room) => (
                <option key={room.id} value={room.id}>
                  {room.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Depart On</label>
            <input type="date" value={date} onChange={handleDateChange} />
          </div>

          <button className="search-button">Check Availability</button>
        </div>

        {/* Right Side: Image Slider */}
        <div className="slider-section">
          <Slider {...sliderSettings}>
            <div>
              <img src="/images/banner1.jpg" alt="Ad 1" />
            </div>
            <div>
              <img src="/images/banner2.jpg" alt="Ad 2" />
            </div>
            <div>
              <img src="/images/banner3.jpg" alt="Ad 3" />
            </div>
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default BookingPage;
